import Enumerator from '../global/Enumerator';

export const contactEmploymentBases = [
  'none',
  'full_time',
  'part_time',
  'casual',
  'sole_trader',
  'in_a_company',
  'in_a_partnership',
  'contract'
];

export class ContactEmploymentBasis extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'full_time';
        break;
      case '2':
        correctOption = 'part_time';
        break;
      case '3':
        correctOption = 'casual';
        break;
      case '4':
        correctOption = 'sole_trader';
        break;
      case '5':
        correctOption = 'in_a_company';
        break;
      case '6':
        correctOption = 'in_a_partnership';
        break;
      case '7':
        correctOption = 'contract';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ContactEmploymentBasis.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  full_time: {
    get title() {
      return 'Full time';
    }
  },
  part_time: {
    get title() {
      return 'Part time';
    }
  },
  casual: {
    get title() {
      return 'Casual';
    }
  },
  sole_trader: {
    get title() {
      return 'Sole trader';
    }
  },
  in_a_company: {
    get title() {
      return 'In a company';
    }
  },
  in_a_partnership: {
    get title() {
      return 'In a partnership';
    }
  },
  contract: {
    get title() {
      return 'Contract';
    }
  }
});

export default {
  contactEmploymentBases,
  ContactEmploymentBasis
};
